import WhetherIconContainer from "../../../Components/Icon/WhetherIcon/WhetherIconContainer";

const WetherIcon = () => {
  return <WhetherIconContainer />;
};

export default WetherIcon;
